// 阿里OSS
export default {
  default: {
    region: 'oss-cn-beijing',
    endPoint: 'oss-cn-beijing.aliyuncs.com',
    accessKeyId: 'LTAIOrpFKrDqsQ2c',
    accessKeySecret: '1Qp8huLETbWiBBJvHXJ7MOIhtKuA1G'
  },
  // 正式
  product: {
    bucket: 'mass-entrepreneurship'
  },
  // 开发
  develop: {
    bucket: 'mass-entrepreneurship'
  },
  // 本地
  local: {
    bucket: 'mass-entrepreneurship'
  }
}
